/* rails-erb-loader-dependencies ../config/routes.rb */

const path = path => {
  return path
}

export { path }
